enum METHODS {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
}

// https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
// object will be subject to JSON.stringify
type RequestBody =
  | File
  | string
  | URLSearchParams
  | FormData
  | object
  | undefined;

const defaultHeader = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
};

const buildPayload = (
  method: string,
  body: RequestBody,
  headers = {},
): RequestInit => {
  let payload: RequestInit = {
    method,
    credentials: 'same-origin',
    headers: {
      ...defaultHeader,
      ...headers,
    },
  };

  if (body) {
    payload =
      typeof body === 'object'
        ? { ...payload, body: JSON.stringify(body) }
        : { ...payload, body };
  }

  return payload;
};

export default class API {
  public static get(path: string, headers: object = {}) {
    const payload = buildPayload(METHODS.GET, undefined, headers);
    return fetch(path, payload);
  }

  public static post(
    path: string,
    body: RequestBody = {},
    headers: object = {},
  ) {
    const payload = buildPayload(METHODS.POST, body, headers);
    return fetch(path, payload);
  }
  public static put(
    path: string,
    body: RequestBody = {},
    headers: object = {},
  ) {
    const payload = buildPayload(METHODS.PUT, body, headers);
    return fetch(path, payload);
  }

  public static delete(
    path: string,
    body: RequestBody = {},
    headers: object = {},
  ) {
    const payload = buildPayload(METHODS.DELETE, body, headers);
    return fetch(path, payload);
  }
}
